module.exports = __webpack_public_path__ + "static/media/HilfeIcon.70ab2941.png";